export let appMicrosoftPlaces = "BnS9qe";
export let hybridspacePlacesTitle = "yF3e4";
export default {appMicrosoftPlaces,hybridspacePlacesTitle};